export const INSPECTOR_FORM_PROPS = {
	className: 'rde-inspector-form',
	colon: false,
	layout: 'vertical',
} as const;
